
import * as pathToRegexp from 'path-to-regexp'

export default {
    name: 'Breadcrumb',

    props: {
        backUrl: {
            type: String
        },
        backName: {
            type: String
        },
        dtlState: {
            type: Boolean
        }
    },
    data() {
        return {
            levelList: null
        }
    },
    watch: {
        $route() {
            this.getBreadcrumb()
        }
    },
    methods: {
        getBreadcrumb() {
            if (this.dtlState == false) {
                // 过滤有没有加title的字段
                let matched = this.$route.matched.filter((item) => item.meta && item.meta.title)
                const first = matched[0]

                if (!this.isDashboard(first)) {
                    matched = [{ path: '/', meta: { title: '首页' } }].concat(matched)
                }
                this.levelList = matched.filter((item) => item.meta && item.meta.title && item.meta.breadcrumb !== false)
                if (this.backUrl) {
                    let backData = {
                        path: this.backUrl,
                        meta: { title: this.backName }
                    }
                    this.levelList.splice(1, 0, backData)
                }
            } else {
                // 过滤有没有加title的字段
                let matched = this.$route.matched.filter((item) => item.meta && item.meta.title)
                const first = matched[0]

                if (!this.isDashboard(first)) {
                    matched = [
                        { path: '/', meta: { title: '首页' } },
                        { path: '/gameList', meta: { title: '全部游戏' } }
                    ].concat(matched)
                }
                this.levelList = matched.filter((item) => item.meta && item.meta.title && item.meta.breadcrumb !== false)
                if (this.backUrl) {
                    let backData = {
                        path: this.backUrl,
                        meta: { title: this.backName }
                    }
                    this.levelList.splice(2, 0, backData)
                }
            }
            console.log(this.levelList);
            
        },
        // 判断是不是首页
        isDashboard(route) {
            const name = route && route.name
            if (!name) {
                return false
            }
            return name.trim().toLocaleLowerCase() === '/'.toLocaleLowerCase()
        },
        handleLink(item) {
            const { redirect, path } = item
            if (redirect) {
                this.$router.push(redirect)
                return
            }
            this.$router.push(this.pathCompile(path))
        },
        pathCompile(path) {
            const { params } = this.$route
            let toPath = pathToRegexp.compile(path)
            return toPath(params)
        }
    },
    created() {
        this.getBreadcrumb()
    }
}
